import React from "react";

type ListingModalSwapLimitContentProps = React.ComponentProps<"div">;

export const ListingModalSwapLimitContent = ({
  className,
  children,
  ...props
}: ListingModalSwapLimitContentProps) => {
  return (
    <div className={"space-y-[16px]"} {...props}>
      {children}
    </div>
  );
};
